import { PriorityTaskQueue } from 'owa-task-queue';

/**
 * Initialize the get persona photo task queue.
 * The queue will control how many getPersonaPhoto requests to make at any given point
 */
const getPersonaPhotoQueue: PriorityTaskQueue<void> = new PriorityTaskQueue<void>({
    taskDelay: 500,
});

export default getPersonaPhotoQueue;
